/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React, { useEffect } from "react";
import { BasicSettingsDetails } from "../../auth/core/_requests";

const PrivacyPolicy = () => {
  const [data, SetData] = React.useState<any>();

  useEffect(() => {
    BasicSettingsDetails().then((res) => {
            SetData(res?.data[0].privacyPolicy);
    });
  }, []);
  return (
    <section className="container-fluid">
      <div className="row">

        <section className="content-section">
          <div className="policy-container">
            <div>
              <h3>Privacy Policy</h3>
              <div dangerouslySetInnerHTML={{ __html: data }} />
            </div>
          </div>
        </section>

      </div>
    </section>
  );
};

export default PrivacyPolicy;
